import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import RouterDetailsComponent from "../components/sites/RouterDetailsComponent";

const RouterDetailsPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Router Details"
        routes={[
          { title: "Home", path: "/" },
          { title: "Sites", path: "/sites" },
        ]}
      />
      <RouterDetailsComponent />
    </>
  );
};
export default RouterDetailsPage;
